import { render, staticRenderFns } from "./doctorClincs.vue?vue&type=template&id=0f706fa1&"
import script from "./doctorClincs.vue?vue&type=script&lang=js&"
export * from "./doctorClincs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports